module.exports = __webpack_public_path__ + "img/ico055.768ae19e.svg";